import { create } from "zustand";

export interface CaseItem {
  caseID:string;
  caseId: string;
  caseNumber: string | null | undefined;
  iceClaimNumber: string | null | undefined;
  claimId: string | null;
  claimStatus: string | null;
  caseStatus: string;
  isManual: boolean;
  funeralPackageSourceType?: "MANUAL" | "POLICY";
  policyNumber?: string | null;
  assignedTo?: string;
  assigned_to?: string;

  claimant: {
    title: string;
    initials:string,
    first_name: string;
    last_name: string;
    date_of_birth:string;
    identification_type: string;
    identification_number: string;
    contact_number: string;
    email: string;
    gender:string;
    marital_status:string;
    country_of_birth:string;
    country_of_residence:string;
    nationality:string;
    address:string;
    postal_address:string;
    postal_code:string;
    relationship:string;
  };

  deceased: {
    first_name: string;
    last_name: string;
    date_of_death: string;
    identification_number: string;
  };

  bodyRemoval?: any;

  documentResponseDtoList: any[];

  createdAt: string;
  updatedAt: string;
}


interface CaseState {
  cases: CaseItem[];
  totalCount: number;
  statusCounts: Record<string, number>;
  selectedCase: CaseItem | null;

  setCases: (data: any) => void;
  setSelectedCase: (caseItem: CaseItem) => void;
  clearSelectedCase: () => void;
  
}

export const useCaseStore = create<CaseState>((set) => ({
  cases: [],
  totalCount: 0,
  statusCounts: {},
  selectedCase: null,

  setCases: (data) =>
    set({
      cases: data?.cases || [],
      totalCount: data?.totalCount || 0,
      statusCounts: data?.statusCounts || {},
    }),

  setSelectedCase: (caseItem) =>
    set({
      selectedCase: caseItem,
    }),

  clearSelectedCase: () =>
    set({
      selectedCase: null,
    }),
}));
